import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"
import { TenantCRMLayout } from "../../../../TenantProfile"
import { Outlet } from "react-router"

export default function Layout() {
	return (
		<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_USERS}>
			<TenantCRMLayout>
				<Outlet />
			</TenantCRMLayout>
		</ForbidUnlessAuthorized>
	)
}
